import { jsx, jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { colors, s16 } from "@ardoq/design-tokens";
import { Icon, IconName } from "@ardoq/icons";
var LoaderSize = /* @__PURE__ */ ((LoaderSize2) => {
  LoaderSize2[LoaderSize2["SMALL"] = 20] = "SMALL";
  LoaderSize2[LoaderSize2["MEDIUM"] = 50] = "MEDIUM";
  LoaderSize2[LoaderSize2["LARGE"] = 100] = "LARGE";
  return LoaderSize2;
})(LoaderSize || {});
var LoaderColor = /* @__PURE__ */ ((LoaderColor2) => {
  LoaderColor2["BRAND"] = "brand";
  LoaderColor2["GRAY"] = "gray";
  LoaderColor2["LIGHT"] = "light";
  LoaderColor2["WHITE"] = "white";
  return LoaderColor2;
})(LoaderColor || {});
const ARDOQ_LOADER_COLORS = {
  [
    "brand"
    /* BRAND */
  ]: colors.iconBrand,
  [
    "gray"
    /* GRAY */
  ]: colors.iconStrong,
  [
    "light"
    /* LIGHT */
  ]: colors.icon,
  [
    "white"
    /* WHITE */
  ]: colors.iconOnInvertedStrong
};
const LOADER_LABEL_TEXT = "Loading";
const DURATION = "3s";
const STROKE_WIDTH = 15;
const sizeToSpeed = {
  [LoaderSize.SMALL]: 3,
  [LoaderSize.MEDIUM]: 2,
  [LoaderSize.LARGE]: 1
};
const getAnimationCSS = ({ $size }) => {
  const speed = sizeToSpeed[$size];
  const keyFrameName = `spinner${speed}`;
  return css`
    animation: ${keyFrameName} ${DURATION} infinite linear;
    @keyframes ${keyFrameName} {
      to {
        transform: rotate(${speed}turn);
      }
    }
  `;
};
const SpinnerStyle = styled.svg`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  border-radius: 50%;
  background: conic-gradient(#0000, ${(props) => props.$color});
  mask: radial-gradient(
    closest-side,
    #0000
      calc(100% - ${(props) => STROKE_WIDTH / (LoaderSize.LARGE / props.$size)}px),
    #000 0
  );
  ${getAnimationCSS}
`;
const ArdoqLoaderSpinner = ({
  color,
  size
}) => /* @__PURE__ */ jsx(
  SpinnerStyle,
  {
    viewBox: `0 0 ${size} ${size}`,
    xmlns: "http://www.w3.org/2000/svg",
    $color: color,
    $size: size
  }
);
const ArdoqLoaderContainer = styled.div`
  display: flex;
  gap: 12px;
`;
const ARDOQ_LOADER_COMPONENT_SELECTOR = ArdoqLoaderContainer.toString();
const LoaderLabelContainer = styled.div`
  font-weight: 600;
  color: ${colors.textModerate};
`;
const toIconSize = (size) => {
  return size;
};
const LoaderComponent = ({ size, isSpinner, color }) => isSpinner ? /* @__PURE__ */ jsx(ArdoqLoaderSpinner, { size, color }) : /* @__PURE__ */ jsx(
  Icon,
  {
    iconName: IconName.ARDOQ_LOGO_LOADER,
    iconSize: toIconSize(size),
    color
  }
);
const ArdoqLoaderComponent = ({
  labelPosition = "vertical",
  loaderType = "logo",
  loaderText = LOADER_LABEL_TEXT,
  size,
  loaderColor,
  hideSpinner
}) => {
  const color = ARDOQ_LOADER_COLORS[loaderColor];
  const isSpinner = loaderType === "spinner";
  const isHorizontalLabel = labelPosition === "horizontal";
  const containerStyle = {
    fontSize: size === LoaderSize.SMALL ? s16 : "20px",
    alignItems: isHorizontalLabel ? "flex-end" : "center",
    flexDirection: isHorizontalLabel ? "row" : "column"
  };
  return /* @__PURE__ */ jsxs(ArdoqLoaderContainer, { style: containerStyle, children: [
    !hideSpinner && /* @__PURE__ */ jsx(LoaderComponent, { color, size, isSpinner }),
    loaderText && /* @__PURE__ */ jsx(
      LoaderLabelContainer,
      {
        style: {
          textAlign: isSpinner ? "center" : void 0,
          lineHeight: size === LoaderSize.SMALL ? "18px" : "24px"
        },
        children: loaderText
      }
    )
  ] });
};
export {
  ARDOQ_LOADER_COLORS,
  ARDOQ_LOADER_COMPONENT_SELECTOR,
  ArdoqLoaderComponent,
  ArdoqLoaderSpinner,
  LOADER_LABEL_TEXT,
  LoaderColor,
  LoaderSize
};
//# sourceMappingURL=index.js.map
